(() => {
  const backToTop = document.getElementById('ncs-back-to-top');
  const footer = document.querySelector('footer');

  if (!backToTop || !footer) return;

  backToTop.hidden = false;
  backToTop.classList.remove('is-visible');

  const observer = new IntersectionObserver(
    ([entry]) => {
      backToTop.classList.toggle('is-visible', entry.isIntersecting);
    },
    {
      threshold: 0.05
    }
  );

  observer.observe(footer);
})();